"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = watchListTodos;
exports.isActionTrackingToBeAcknowledged = isActionTrackingToBeAcknowledged;
exports.onApplyUserGridSettings = onApplyUserGridSettings;
exports.onCommonService = onCommonService;
exports.onFetchJwtTokenSN = onFetchJwtTokenSN;
exports.onFetchUserPersona = onFetchUserPersona;
exports.onFetchUserSession = onFetchUserSession;
exports.onFindByUserAppAndFunctions = onFindByUserAppAndFunctions;
exports.onGetUserGridColums = onGetUserGridColums;
var _effects = require("redux-saga/effects");
var _baseLayout = require("./base-layout.constants");
var _baseLayout2 = require("./base-layout.actions");
var _baseLayout3 = _interopRequireWildcard(require("./base-layout.service"));
var service = _baseLayout3;
var _baseLayout4 = _interopRequireDefault(require("./base-layout.gateway"));
var _reduxSaga = require("redux-saga");
var _reactToastify = require("react-toastify");
var _gridSettings = require("../../components/GridSettings/grid-settings.service");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* onGetUserGridColums(action) {
  try {
    const result = yield (0, _effects.call)(_gridSettings.getUserGridColumns, action.key);
    if (result.columns[0]) {
      let adaSetting = {
        adaBold: result.columns[0].filterName === "Y" ? true : false,
        //adabold - filter Name
        adaLargeFont: result.columns[0].filterValue === "Y" ? true : false,
        //adaLarge - filterValue
        adaShadeColor: result.columns[0].visibleIndicator.substring(0, 9),
        //adaColor
        adaShade: result.columns[0].visibleIndicator.at(9) === "Y" ? true : false,
        // adaShade
        adaDarkCell: result.columns[0].sortIndicator === "Y" ? true : false //adaDark cell - SortIndicator
      };

      yield (0, _effects.put)((0, _baseLayout2.setUserGridColumns)(adaSetting));
    } else if (result.columns.length === 0) {
      let adaSetting = {
        adaBold: false,
        adaLargeFont: false,
        adaShadeColor: "#e0e5ff",
        adaShade: false,
        adaDarkCell: false
      };
      yield (0, _effects.put)((0, _baseLayout2.setUserGridColumns)(adaSetting));
    }
  } catch (error) {
    console.log(error);
  }
}
function* onApplyUserGridSettings(action) {
  try {
    const applyUserGridVO = {
      gridKey: action.gridKey,
      userGridColumnList: action.userGridColumnList
    };
    yield (0, _effects.call)(_gridSettings.applyUserGridSettings, applyUserGridVO);
  } catch (error) {
    console.log(error);
  }
}
function* onFindByUserAppAndFunctions(action) {
  try {
    const result = yield (0, _effects.call)(service.findByUserAppAndFunctions, action);
    if (result) {
      const brandCodes = result.brands;
      if (result.userAppFunctions && result.userAppFunctions.cc && result.userAppFunctions.cc.length > 0) {
        const claims = result.userAppFunctions.cc;
        claims.forEach(c => {
          if (c.k === "PPHSID" && c.v && c.v.length > 0) {
            localStorage.setItem("PPHSID", c.v[0]);
          }
        });
      }
      yield (0, _effects.put)((0, _baseLayout2.findByUserAppAndFunctionsSuccess)(result));
      if (brandCodes) yield (0, _effects.put)((0, _baseLayout2.updateBrands)(brandCodes.brands));
      // Please move this code to ui_gcs.
      // const brands = yield call(
      //   BLGateway.fetch_brand_details,
      //   brandCodes.brands
      // );
      // if (brands) yield put(updateBrands(brands));
      // else throw new Error("Error in fetching brands");
    } else throw new Error("Error in fetching details");
  } catch (err) {
    yield (0, _effects.put)((0, _baseLayout2.findByUserAppAndFunctionsError)(false));
  }
}
function* onFetchJwtTokenSN(action) {
  try {
    const jwtToken = yield (0, _effects.call)(_baseLayout3.getJwtTokenSN, action.userId, action.appName);
    console.log("Action", action);
    const data = {
      jwtToken: jwtToken,
      decoded: action.decoded,
      appName: action.appName
    };
    yield (0, _effects.put)((0, _baseLayout2.setJwttokenSN)(data));
  } catch (err) {
    yield (0, _effects.put)((0, _baseLayout2.setJwttokenSN)(null));
  }
}
function* onFetchUserSession(action) {
  try {
    const userSession = yield (0, _effects.call)(service.getUserSessionService, action.cacheKey);
    yield (0, _effects.put)((0, _baseLayout2.getUserSessionToken)(userSession));
  } catch (err) {
    yield (0, _effects.put)((0, _baseLayout2.getUserSessionToken)(null));
  }
}
function* isActionTrackingToBeAcknowledged(action) {
  while (true) {
    yield (0, _effects.put)((0, _baseLayout2.loadingActionTrackingItemsToBeAcknowledged)(true));
    try {
      const response = yield (0, _effects.call)(service.isActionTrackingToBeAcknowledged, action.input);
      // yield put(onFetchStuffSuccess(items));
      if (response && response.pageCount) {
        yield (0, _effects.put)((0, _baseLayout2.setNumberOfActionTrackingItemsToBeAcknowledged)(response.pageCount));
      } else {
        yield (0, _effects.put)((0, _baseLayout2.setNumberOfActionTrackingItemsToBeAcknowledged)(null));
      }
      yield (0, _effects.put)((0, _baseLayout2.isActionTrackingToBeAcknowledgedError)(response && response.pageCount) || null);
      yield (0, _effects.put)((0, _baseLayout2.loadingActionTrackingItemsToBeAcknowledged)(false));
      yield (0, _effects.call)(_reduxSaga.delay, 60000);
    } catch (e) {
      // yield put(onFetchStuffFailure(e));
      yield (0, _effects.put)((0, _baseLayout2.isActionTrackingToBeAcknowledgedError)(null));
      yield (0, _effects.put)((0, _baseLayout2.loadingActionTrackingItemsToBeAcknowledged)(false));
    }
  }
}
function* onCommonService(action) {
  try {
    const output = yield (0, _effects.call)(service[action.service], action.args || null);
    const args = (0, _baseLayout2.commonServiceSuccess)(output);
    args[action.service] = false;
    yield (0, _effects.put)(args);
    action.callback && action.callback(null, output);
  } catch (err) {
    const args = (0, _baseLayout2.commonServiceError)(err);
    args.service = action.service;
    yield (0, _effects.put)(args);
    action.callback && action.callback(err);
  }
}
function* pollActionTrackingToBeAcknowledged(action) {
  // yield take(START_POLLING);
  yield (0, _effects.race)([(0, _effects.call)(isActionTrackingToBeAcknowledged, action), (0, _effects.take)(_baseLayout.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED_ERROR)]);
}
function* onFetchUserPersona(action) {
  try {
    const userPersona = yield (0, _effects.call)(service.getPersonasForUserApp, action.userId, action.appName);
    yield (0, _effects.put)((0, _baseLayout2.setPersonaUser)(userPersona));
  } catch (err) {
    _reactToastify.toast.error(err.message, {
      position: _reactToastify.toast.POSITION.TOP_RIGHT,
      allowHtml: true,
      autoClose: true
    });
  }
}
function* watchListTodos() {
  yield [(0, _effects.takeLatest)(_baseLayout.FINDBYUSERAPPANDFUNCTIONS, onFindByUserAppAndFunctions)];
  yield [(0, _effects.takeLatest)(_baseLayout.GET_PERSONA_FOR_USER, onFetchUserPersona)];
  yield (0, _effects.takeLatest)(_baseLayout.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED, pollActionTrackingToBeAcknowledged);
  yield [(0, _effects.takeLatest)(_baseLayout.FETCH_JWTTOKENSN, onFetchJwtTokenSN)];
  yield [(0, _effects.takeLatest)(_baseLayout.GET_USER_SESSION, onFetchUserSession)];
  yield (0, _effects.takeEvery)(_baseLayout.COMMON_SERVICE, onCommonService);
  yield [(0, _effects.takeLatest)(_baseLayout.GET_USER_GRID_COLUMNS, onGetUserGridColums)];
  yield (0, _effects.takeLatest)(_baseLayout.APPLY_USER_GRID_SETTING, onApplyUserGridSettings);
}